import { normalizeDimension } from "../../../../helpers/utils";

const style = ({ justifyContent, childrenSpacing, isFullWidth }) => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: justifyContent || "space-between",
    alignItems: "center",
    width: "100%",
    "& .buttonsRow_item": {
        ...(isFullWidth && {
            width: "100%",
        }),
        "& + .buttonsRow_item": {
            marginLeft: normalizeDimension(childrenSpacing, true),
        },
    },
});

export default style;
